import React, { memo, useState } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import Scrollbars from 'react-custom-scrollbars';
import * as yup from 'yup';

import { Profile } from '../components';
import {
  mapGroupStates,
  setAllMapGroupSetStates,
} from '../modules/Global';
import {
  MapGroupInviteParticipant,
  MapGroupUpdateInvitation,
} from '../modules/API';
import Cookies from '../modules/Cookies';

let rendered = false;

let alertButtonResolve = () => undefined;
let alertButtonReject = () => undefined;
const alertUnregisteredUser = () =>
  new Promise((resolve, reject) => {
    alertButtonResolve = resolve;
    alertButtonReject = reject;
  });

const MapGroupParticipantsModalComponent = memo(() => {
  const [showAlert, setShowAlert] = useState(false);
  const [email, setEmail] = useState('');
  const {
    CurrentMap: { ori },
  } = window.Gdata;
  const map = ori[0];
  const [mapGroups, setMapGroupsState] = useState(map.mapGroups || []);
  mapGroupStates.mapGroupParticipantsModal = setMapGroupsState;

  const invite = async () => {
    if (
      !(await yup
        .string()
        .required()
        .email()
        .isValid(email))
    ) {
      alert(window.resolveLang('メールアドレスの形式が不正です'));
      return;
    }

    $('#MapGroupParticipantsModal').addClass('freeze');

    try {
      const {
        mail_is_not_registered,
        mapGroup,
      } = await MapGroupInviteParticipant({
        map_id: map._id,
        session: Cookies.get('session'),
        mail: email,
        force: false,
        locale: window.hlocale,
      });

      if (mail_is_not_registered) {
        try {
          setShowAlert(true);
          await alertUnregisteredUser();
          const result = await MapGroupInviteParticipant({
            map_id: map._id,
            session: Cookies.get('session'),
            mail: email,
            force: true,
            locale: window.hlocale,
          });
          setAllMapGroupSetStates([result.mapGroup, ...mapGroups]);
        } catch (error) {
          console.log(error);
        }
      } else {
        setAllMapGroupSetStates([mapGroup, ...mapGroups]);
      }
    } catch (error) {
      if (error.responseJSON && error.responseJSON.message) {
        alert(error.responseJSON.message);
      } else {
        alert(window.resolveLang('エラーが発生しました。'));
      }
    }

    setShowAlert(false);
    $('#MapGroupParticipantsModal').removeClass('freeze');
  };

  /**
   * @type {(mail: string, index: number) => () => Promise<void>}
   */
  const deleteInvite = (mail, index) => async () => {
    if (!confirm(window.resolveLang('削除しますか？'))) {
      return;
    }

    $('#MapGroupParticipantsModal').addClass('freeze');

    try {
      await MapGroupUpdateInvitation({
        map_id: map._id,
        session: Cookies.get('session'),
        mail,
        status: 'delete',
        locale: window.hlocale,
      });

      mapGroups.splice(index, 1);
      setAllMapGroupSetStates([...mapGroups]);
    } catch (error) {
      if (error.responseJSON && error.responseJSON.message) {
        alert(error.responseJSON.message);
      } else {
        alert(window.resolveLang('エラーが発生しました。'));
      }
    }

    $('#MapGroupParticipantsModal').removeClass('freeze');
  };

  return (
    <div className="modalInner">
      <div className="modalHead">
        <p>{window.resolveLang('マップの共有')}</p>
        <i className="closeModal" />
      </div>
      <ModalContainerBody className="modalBody">
        <InputContainerDiv>
          <input
            type="text"
            className="inpBig"
            placeholder={window.resolveLang('メールアドレス')}
            value={email}
            onChange={({ target: { value } }) => setEmail(value)}
          />
          <button className="btnBlue" onClick={invite}>
            {window.resolveLang('招待')}
          </button>
        </InputContainerDiv>
        <StyledScrollbars autoHide>
          {mapGroups.map((mapGroup, index) => (
            <ParticipantDiv key={index}>
              <Profile
                size={40}
                imageId={mapGroup.icon_url}
                title={mapGroup.nickname}
                name={mapGroup.mail}
              />
              {mapGroup.accepted === '0' && (
                <div>{window.resolveLang('招待中')}</div>
              )}
              <button onClick={deleteInvite(mapGroup.mail, index)}>✖︎</button>
            </ParticipantDiv>
          ))}
          {!mapGroups.length && (
            <p>{window.resolveLang('現在招待しているユーザがいません。')}</p>
          )}
        </StyledScrollbars>
        <FooterContainerDiv>
          <button className="btnBlue closeModal">
            {window.resolveLang('完了')}
          </button>
        </FooterContainerDiv>
      </ModalContainerBody>
      <div className="skFadingCircleContainer">
        <div className="sk-fading-circle">
          <div className="sk-circle1 sk-circle" />
          <div className="sk-circle2 sk-circle" />
          <div className="sk-circle3 sk-circle" />
          <div className="sk-circle4 sk-circle" />
          <div className="sk-circle5 sk-circle" />
          <div className="sk-circle6 sk-circle" />
          <div className="sk-circle7 sk-circle" />
          <div className="sk-circle8 sk-circle" />
          <div className="sk-circle9 sk-circle" />
          <div className="sk-circle10 sk-circle" />
          <div className="sk-circle11 sk-circle" />
          <div className="sk-circle12 sk-circle" />
        </div>
      </div>
      {showAlert && (
        <AlertDiv>
          <p>
            {window.resolveLang(
              '入力されたユーザは存在しません。Map Life に招待しますか？'
            )}
          </p>
          <div>
            <button
              className="btnWhite"
              onClick={() => {
                alertButtonReject();
              }}
            >
              {window.resolveLang('キャンセル')}
            </button>
            <button
              className="btnBlue"
              onClick={() => {
                alertButtonResolve();
              }}
            >
              {window.resolveLang('招待')}
            </button>
          </div>
        </AlertDiv>
      )}
    </div>
  );
});

window.openMapGroupParticipantsModalComponent = () => {
  if (!rendered) {
    ReactDOM.render(
      <MapGroupParticipantsModalComponent />,
      document.getElementById('MapGroupParticipantsModal')
    );

    rendered = true;
  }

  window.openModal('#MapGroupParticipantsModal');
};

//#region styles
const ModalContainerBody = styled.div`
  display: flex;
  flex-direction: column;
`;
const InputContainerDiv = styled.div`
  background: white;
  padding: 16px;
  display: flex;

  button {
    height: 40px;
    margin-left: 16px;
  }
`;
const StyledScrollbars = styled(Scrollbars)`
  height: 100%;
  width: 100%;
  flex: 1;

  & > div:first-child {
    padding: 16px;

    & > {
      * {
        padding-bottom: 8px;
      }

      *:last-child {
        padding-bottom: 0;
      }
    }

    & > p {
      font-size: 14px;
      font-weight: bold;
      padding: 10px 0;
      text-align: center;
      color: #888;
    }
  }
`;
const ParticipantDiv = styled.div`
  display: flex;
  align-items: center;

  & > {
    /* Profile */
    *:first-child {
      flex: 1;
      min-width: 0;
    }

    div:nth-child(2) {
      background: #ecaa14;
      color: white;
      font-weight: bold;
      padding: 10px;
      border-radius: 4px;
    }

    button {
      display: block;
      cursor: pointer;
      padding: 10px 5px;
      margin-left: 8px;

      &:hover {
        opacity: 0.8;
      }
    }
  }
`;
const FooterContainerDiv = styled.div`
  background: white;
  padding: 16px;
  display: flex;
  flex-direction: row-reverse;
`;
const AlertDiv = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  z-index: 10000;
  padding: 16px;
  width: 300px;
  border-radius: 10px;

  & > {
    p {
      line-height: 1.5;
    }

    div {
      margin-top: 16px;
      justify-content: flex-end;
      display: flex;

      & > button:first-child {
        margin-right: 16px;
      }
    }
  }
`;
//#endregion
